var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.setting!=null)?_c('div',[_c('iframe',{attrs:{"width":_vm.setting.width,"height":_vm.setting.height,"src":_vm.setting.src,"frameborder":"0","allowFullScreen":_vm.setting.allowFullScreen}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }